import { call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { Response } from '../../../interfaces/index';
import store from '../..';
import { setLocalClassifictations } from './actions';
import axiosServices from '../../../services/axiosServicesLocais';

export function* getLocalClassifications() {
  try {
    const response: Response = yield call(axiosServices.get, '/admin/classificacoes-locais/v1/classificacoes-validas');
    store.dispatch(setLocalClassifictations(response.data.data));
  } catch (err: any) {
    toast.error(`⚠ ${err?.response.data?.notifications?.map((item: any) => `${item.message}\n`)}`);
  }
}
